import { useRef } from 'react';
import { cn } from '../../lib/utils';

export function MovingBorder({
  children,
  duration = 2000,
  className,
  containerClassName,
  borderRadius = '1rem',
  as: Component = 'button',
  ...props
}) {
  return (
    <Component
      className={cn(
        'relative p-[1px] overflow-hidden',
        containerClassName
      )}
      style={{ borderRadius }}
      {...props}
    >
      {/* Animated border gradient */}
      <div
        className="absolute inset-0"
        style={{ borderRadius }}
      >
        <div
          className="absolute inset-[-100%] animate-[spin_3s_linear_infinite]"
          style={{
            background: `conic-gradient(from 90deg at 50% 50%, #3b82f6 0%, #8b5cf6 25%, #3b82f6 50%, #8b5cf6 75%, #3b82f6 100%)`,
          }}
        />
      </div>

      {/* Inner content with background */}
      <div
        className={cn(
          'relative bg-card px-4 py-2',
          className
        )}
        style={{ borderRadius: `calc(${borderRadius} - 1px)` }}
      >
        {children}
      </div>
    </Component>
  );
}

export function MovingBorderButton({
  children,
  className,
  ...props
}) {
  return (
    <MovingBorder
      containerClassName="group"
      className={cn(
        'flex items-center justify-center gap-2 text-foreground font-medium transition-colors',
        'hover:bg-muted',
        className
      )}
      {...props}
    >
      {children}
    </MovingBorder>
  );
}

// Simplified border beam effect for cards
export function BorderBeam({ className, size = 200, duration = 12, delay = 0 }) {
  return (
    <div
      style={{
        '--size': size,
        '--duration': duration,
        '--delay': `-${delay}s`,
      }}
      className={cn(
        'pointer-events-none absolute inset-0 overflow-hidden rounded-[inherit]',
        "[mask-image:linear-gradient(to_right,transparent,white_20%,white_80%,transparent)]",
        className
      )}
    >
      <div
        className="absolute inset-0 animate-border-beam"
        style={{
          width: 'var(--size)',
          background: 'linear-gradient(90deg, transparent, rgba(59, 130, 246, 0.5), transparent)',
          offsetPath: `rect(0 auto auto 0 round calc(var(--size) / 2))`,
        }}
      />
    </div>
  );
}
